import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from "react-i18next";

function ContactUsNoTranslation(props) {
  const { t } = props;
  return (
    <Link to='/contact-us'>
      <div className="common-contact-us">

        <div className="contact-info">
          <p className="contact-text"><b >{t('general.footerContact', { framework: 'React' })}</b><br /> <i>+34 633229424</i><br /><i>+34 696857832</i></p>
        </div>
      </div>
    </Link>
  );
}

const ContactUs = withTranslation('common')(ContactUsNoTranslation)

export default ContactUs;


// WEBPACK FOOTER //
// ./src/features/common/ContactUs.js